import {
  IdentityMelcoModelsProductListItem,
  SelectField,
} from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { useAllProducts } from "../../hooks/useAllProduts";


type DisplayCouponsProductsDropDownProps = {

  callbackFn?: any;
};

export const DisplayCouponsProductsDropDown: React.FC<
  DisplayCouponsProductsDropDownProps
> = ({ callbackFn }) => {
  const { t } = useTranslation();
  const { products } = useAllProducts()
  return (
    <>
      <SelectField
        name="product_code"
        label={t("licenses.basic.search.product.title")}
        options={(products ?? []).map(
          (product: IdentityMelcoModelsProductListItem) => {
            return {
              label: product.name!,

              value: product.code!,
              product: product,
            };
          }
        )}
        showSearch
        optionFilterProp="label"
        onChange={(value, product) => callbackFn(value, product)}
      />
    </>
  );
};
